// Service Request Status Constants
export const SERVICE_REQUEST_STATUS = {
  CREATED: 0,
  APPROVED: 1,
  COMPLETED: 2,
  REJECTED: 3,
  IN_PROGRESS: 4,
  CANCELED: 5,
  PENDING: 6,
  ON_HOLD: 7,
  CLOSED: 8,
} as const;

// Service Request Status Display Names
export const SERVICE_REQUEST_STATUS_DISPLAY = {
  [SERVICE_REQUEST_STATUS.CREATED]: "created",
  [SERVICE_REQUEST_STATUS.APPROVED]: "approved",
  [SERVICE_REQUEST_STATUS.COMPLETED]: "completed",
  [SERVICE_REQUEST_STATUS.REJECTED]: "rejected",
  [SERVICE_REQUEST_STATUS.IN_PROGRESS]: "in progress",
  [SERVICE_REQUEST_STATUS.CANCELED]: "canceled",
  [SERVICE_REQUEST_STATUS.PENDING]: "pending",
  [SERVICE_REQUEST_STATUS.ON_HOLD]: "on hold",
  [SERVICE_REQUEST_STATUS.CLOSED]: "closed",
} as const;

// Service Request Status Type
export type ServiceRequestStatusType =
  (typeof SERVICE_REQUEST_STATUS)[keyof typeof SERVICE_REQUEST_STATUS];
